//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/teleport/gossip.proto (package dxos.mesh.teleport.gossip, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any, EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { PublicKey } from "../../keys_pb.js";
import { file_dxos_keys } from "../../keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/teleport/gossip.proto.
 */
export const file_dxos_mesh_teleport_gossip: GenFile = /*@__PURE__*/
  fileDesc("Ch9keG9zL21lc2gvdGVsZXBvcnQvZ29zc2lwLnByb3RvEhlkeG9zLm1lc2gudGVsZXBvcnQuZ29zc2lwIsoBCg1Hb3NzaXBNZXNzYWdlEiUKB3BlZXJfaWQYASABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EhIKCmNoYW5uZWxfaWQYAiABKAkSKAoKbWVzc2FnZV9pZBgDIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSLQoJdGltZXN0YW1wGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIlCgdwYXlsb2FkGAogASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueTJdCg1Hb3NzaXBTZXJ2aWNlEkwKCEFubm91bmNlEiguZHhvcy5tZXNoLnRlbGVwb3J0Lmdvc3NpcC5Hb3NzaXBNZXNzYWdlGhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5YgZwcm90bzM", [file_google_protobuf_empty, file_google_protobuf_any, file_google_protobuf_timestamp, file_dxos_keys]);

/**
 * @generated from message dxos.mesh.teleport.gossip.GossipMessage
 */
export type GossipMessage = Message<"dxos.mesh.teleport.gossip.GossipMessage"> & {
  /**
   * @generated from field: dxos.keys.PublicKey peer_id = 1;
   */
  peerId?: PublicKey;

  /**
   * / Used to route different payload types to correct listeners.
   *
   * @generated from field: string channel_id = 2;
   */
  channelId: string;

  /**
   * / Peer tracks what had been sent by message id.
   *
   * @generated from field: dxos.keys.PublicKey message_id = 3;
   */
  messageId?: PublicKey;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 4;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: google.protobuf.Any payload = 10;
   */
  payload?: Any;
};

/**
 * Describes the message dxos.mesh.teleport.gossip.GossipMessage.
 * Use `create(GossipMessageSchema)` to create a new message.
 */
export const GossipMessageSchema: GenMessage<GossipMessage> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_gossip, 0);

/**
 * @generated from service dxos.mesh.teleport.gossip.GossipService
 */
export const GossipService: GenService<{
  /**
   * @generated from rpc dxos.mesh.teleport.gossip.GossipService.Announce
   */
  announce: {
    methodKind: "unary";
    input: typeof GossipMessageSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_mesh_teleport_gossip, 0);

